import { render, staticRenderFns } from "./tiktok_prize_dialog.vue?vue&type=template&id=b883df0a&scoped=true"
import script from "./tiktok_prize_dialog.vue?vue&type=script&lang=ts"
export * from "./tiktok_prize_dialog.vue?vue&type=script&lang=ts"
import style0 from "./tiktok_prize_dialog.vue?vue&type=style&index=0&id=b883df0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b883df0a",
  null
  
)

export default component.exports